/* ScandiLabel – sökfält, snabbköp, frakttröskel, storlekshjälp, reveal.
   Inga externa beroenden. Allt som animerar respekterar prefers-reduced-motion. */
(function () {
  'use strict';

  var CALM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. (borttaget) ----------
     Här låg "Beställ inom X" med cut-off 14:00 och tidszonsräkning för
     Europe/Stockholm. §I6 tillåter ingen nedräkning på produktnivå, så
     både raden och hela tidszonshjälpen är borta. Det sparar ~70 rader
     som kördes på varje sidvisning (§J).

     Det som §I6 tillåter – sista beställningsdag före jul, och "Få kvar i
     lager" när leverantörens saldo faktiskt visar det – är statisk text
     och behöver ingen klocka.
  */

  /* ---------- 2. Mysigare tillsammans ---------- */

  function money(ore) {
    var kr = Math.round(ore / 100);
    return kr.toLocaleString('sv-SE') + ' kr';
  }

  function initCompleteLook() {
    document.querySelectorAll('[data-sl-look]').forEach(function (root) {
      var boxes = Array.prototype.slice.call(root.querySelectorAll('input[type=checkbox][data-variant]'));
      var sumEl = root.querySelector('[data-sl-look-sum]');
      var saveEl = root.querySelector('[data-sl-look-save]');
      var btn = root.querySelector('[data-sl-look-add]');
      var base = Number(root.getAttribute('data-base-price') || 0);
      var mainVariant = Number(root.getAttribute('data-main-variant') || 0);
      if (!boxes.length || !btn) return;

      // Summan visar fullpris. Trapprabatten (v3.1 §2) dras i kassan och
      // beror på hela varukorgen, inte bara den här modulen – därför räknas
      // den inte av här. Raden under summan säger bara vilket steg i trappan
      // valet landar på.
      function recalc() {
        var addons = 0;
        var picked = 0;
        boxes.forEach(function (b) {
          if (b.checked) {
            addons += Number(b.getAttribute('data-price') || 0);
            picked++;
          }
        });
        if (sumEl) sumEl.textContent = money(base + addons);
        if (saveEl) {
          // picked + huvudprodukten = antal plagg i ordern.
          if (picked >= 2) {
            saveEl.textContent = 'Tre plagg – 20 % dras av i kassan';
          } else if (picked === 1) {
            saveEl.textContent = 'Två plagg – 10 % dras av i kassan';
          } else {
            saveEl.textContent = 'Välj till ett plagg så dras 10 % av i kassan';
          }
        }
        // Inget är förkryssat, så knappen börjar inaktiv.
        btn.disabled = picked === 0;
        btn.textContent = 'Lägg till valda';
      }

      boxes.forEach(function (b) { b.addEventListener('change', recalc); });
      recalc();

      btn.addEventListener('click', function () {
        var items = boxes.filter(function (b) { return b.checked; })
          .map(function (b) { return { id: Number(b.getAttribute('data-variant')), quantity: 1 }; });
        if (!items.length) return;
        // Huvudprodukten läggs alltid till, först i korgen.
        if (mainVariant) items.unshift({ id: mainVariant, quantity: 1 });

        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = 'Lägger till…';

        fetch(cartRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            return r.json();
          })
          .then(function () {
            // Låt temat uppdatera varukorgslådan.
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            var drawer = document.querySelector('cart-drawer-component, #cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            else window.location.href = cartRoot() + 'cart';
          })
          .catch(function () {
            btn.textContent = 'Något gick fel – försök igen';
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500);
          });
      });
    });
  }

  /* ---------- 3. Kategorichips i söket ---------- */

  function searchRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function goScoped(input, chip) {
    var term = input ? input.value.trim() : '';
    var q = chip ? (term + ' ' + chip.getAttribute('data-query')).trim() : term;
    window.location.href = searchRoot() + 'search?q=' + encodeURIComponent(q) +
      '&options%5Bprefix%5D=last';
  }

  // Flyttar in chipsen i Horizons sökdialog. Mallen ligger i theme.liquid,
  // så markupen är Liquid-renderad och kan läsa kollektionernas URL:er.
  function mountChipsInModal() {
    var form = document.querySelector('.predictive-search-form');
    if (!form || form.querySelector('[data-sl-chips]')) return;
    var tpl = document.getElementById('sl-search-chips-template');
    var anchor = form.querySelector('.predictive-search-form__content-wrapper');
    if (!tpl || !anchor) return;
    form.insertBefore(tpl.content.cloneNode(true), anchor);
  }

  function initSearchChips() {
    mountChipsInModal();
    document.querySelectorAll('[data-sl-chips]').forEach(function (group) {
      if (group.dataset.slReady) return;
      group.dataset.slReady = '1';

      var form = group.closest('form');
      var input = form ? form.querySelector('input[name="q"]') : null;
      var chips = Array.prototype.slice.call(group.querySelectorAll('[data-sl-chip]'));

      // Återställ vald kategori från adressfältet och plocka bort
      // filtersyntaxen ur det synliga fältet.
      if (input) {
        var current = input.value;
        chips.forEach(function (c) {
          var frag = c.getAttribute('data-query');
          if (current && current.indexOf(frag) !== -1) {
            c.setAttribute('aria-pressed', 'true');
            c.classList.add('is-on');
            input.value = current.replace(frag, '').replace(/\s+/g, ' ').trim();
          }
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var term = input ? input.value.trim() : '';
          // Tomt fält: chipet är en genväg till kollektionen.
          if (!term) {
            window.location.href = chip.getAttribute('data-url');
            return;
          }
          var wasOn = chip.getAttribute('aria-pressed') === 'true';
          chips.forEach(function (c) {
            c.setAttribute('aria-pressed', 'false');
            c.classList.remove('is-on');
          });
          if (!wasOn) {
            chip.setAttribute('aria-pressed', 'true');
            chip.classList.add('is-on');
          }
          goScoped(input, wasOn ? null : chip);
        });
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          var active = group.querySelector('[data-sl-chip][aria-pressed="true"]');
          if (!active) return;
          e.preventDefault();
          goScoped(input, active);
        });
      }
    });
  }

  /* ---------- 3a. Synligt sökfält i headern (§E) ---------- */

  function initSearchField() {
    var tpl = document.getElementById('sl-search-field-template');
    var header = document.querySelector('#header-component');
    if (!tpl || !header || header.querySelector('[data-sl-searchfield]')) return;

    // Samma krok som sökchipsen använder – Horizons enda sökutlösare.
    var trigger = header.querySelector('[aria-controls="search-modal"], .header__search');
    if (!trigger || !trigger.parentElement) return;

    trigger.parentElement.insertBefore(tpl.content.cloneNode(true), trigger);
    header.setAttribute('data-sl-search-inline', '');
  }

  /* ---------- 3c. Skugga på headern först efter 12 px (§E) ---------- */

  function initHeaderShadow() {
    var header = document.querySelector('#header-component');
    if (!header) return;
    var ticking = false;

    function apply() {
      ticking = false;
      header.classList.toggle('sl-header--scrolled', window.scrollY > 12);
    }

    apply();
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }, { passive: true });
  }

  /* ---------- 3b. Nalle i tomma varukorgen (§D) ---------- */

  function initEmptyCart() {
    var tpl = document.getElementById('sl-empty-cart-template');
    if (!tpl) return;
    var wraps = document.querySelectorAll(
      '[data-cart-drawer-empty], .cart-page--empty .cart-items__wrapper'
    );
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.querySelector('.sl-empty--cart')) continue;
      w.insertBefore(tpl.content.cloneNode(true), w.firstChild);
    }
  }

  /* v5.3 §2: etikettbytet på Horizons egen knapp är borta. Den knappen
     döljs numera i CSS och vårt block har en egen. Att skriva om en
     främmande knapps text i JS höll bara tills Horizon renderade om det
     tomma läget ur sin <template id="empty-cart-template"> – då kom
     "Fortsätt handla" tillbaka. */

  // Varukorgslådan renderas om varje gång korgen ändras, så tomläget kan
  // dyka upp långt efter sidladdning. Observatören är avstängd tills en
  // låda faktiskt finns, och anropet är debouncat.
  function watchCart() {
    if (!('MutationObserver' in window)) return;

    // Två värdar: varukorgslådan, och varukorgssidan. Båda ritar om sitt
    // tomma läge ur en <template id="empty-cart-template"> när korgen töms,
    // och då måste blocket flyttas in igen. Tidigare bevakades bara lådan,
    // så på /cart försvann Nalle när sista raden togs bort.
    var hosts = [];
    var drawer = document.querySelector('cart-drawer-component, #cart-drawer');
    if (drawer) hosts.push(drawer);
    var page = document.querySelector('.cart-page, #MainContent');
    if (page) hosts.push(page);
    if (!hosts.length) hosts.push(document.body);

    var pending = null;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        initEmptyCart();
        initCartExtras();
      }, 100);
    });
    hosts.forEach(function (h) { obs.observe(h, { childList: true, subtree: true }); });
  }

  /* ---------- 3d. Swatchar på produktkortet (§G) ---------- */

  function initCardSwatches() {
    document.querySelectorAll('[data-sl-card]').forEach(function (card) {
      if (card.dataset.slSwatchReady) return;
      var swatches = card.querySelectorAll('[data-sl-swatch]');
      if (!swatches.length) return;
      card.dataset.slSwatchReady = '1';

      var img = card.querySelector('[data-sl-card-image]');
      if (!img) return;
      var original = img.getAttribute('src');

      function show(src) {
        img.setAttribute('src', src);
        // srcset skulle annars vinna över det nya src:et.
        img.removeAttribute('srcset');
      }

      swatches.forEach(function (sw) {
        var src = sw.getAttribute('data-src');
        sw.addEventListener('mouseenter', function () { show(src); });
        sw.addEventListener('focus', function () { show(src); });
        sw.addEventListener('click', function () {
          show(src);
          swatches.forEach(function (o) { o.classList.remove('is-on'); });
          sw.classList.add('is-on');
          card.dataset.slSwatchLocked = '1';
        });
      });

      // Musen lämnar kortet: tillbaka till utgångsbilden, om inget valts.
      card.addEventListener('mouseleave', function () {
        if (!card.dataset.slSwatchLocked) show(original);
      });
    });
  }

  /* ---------- 3e. Snabbköp (§G) ---------- */

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initQuickBuy() {
    var dlg = document.getElementById('sl-quickbuy');
    if (!dlg || dlg.dataset.slReady) return;
    dlg.dataset.slReady = '1';

    var elImage = dlg.querySelector('[data-sl-quick-image]');
    var elName = dlg.querySelector('[data-sl-quick-name]');
    var elPrice = dlg.querySelector('[data-sl-quick-price]');
    var elOptions = dlg.querySelector('[data-sl-quick-options]');
    var elAdd = dlg.querySelector('[data-sl-quick-add]');
    var elLink = dlg.querySelector('[data-sl-quick-link]');
    var state = null;

    function matches(variant, chosen) {
      for (var i = 0; i < chosen.length; i++) {
        if (chosen[i] !== null && variant.options[i] !== chosen[i]) return false;
      }
      return true;
    }

    function current() {
      for (var i = 0; i < state.data.variants.length; i++) {
        if (matches(state.data.variants[i], state.chosen)) return state.data.variants[i];
      }
      return null;
    }

    // Ett värde är valbart om någon köpbar variant har det värdet
    // tillsammans med de övriga valen.
    function selectable(index, value) {
      var probe = state.chosen.slice();
      probe[index] = value;
      for (var i = 0; i < state.data.variants.length; i++) {
        var v = state.data.variants[i];
        if (v.available && matches(v, probe)) return true;
      }
      return false;
    }

    function render() {
      elOptions.innerHTML = '';

      state.data.options.forEach(function (name, index) {
        var values = [];
        state.data.variants.forEach(function (v) {
          if (values.indexOf(v.options[index]) === -1) values.push(v.options[index]);
        });

        var group = document.createElement('div');
        group.className = 'sl-quick__group';

        var label = document.createElement('span');
        label.className = 'sl-quick__label';
        label.textContent = name;
        group.appendChild(label);

        var row = document.createElement('div');
        row.className = 'sl-quick__values';
        row.setAttribute('role', 'group');
        row.setAttribute('aria-label', name);

        values.forEach(function (value) {
          // Storlek ska alltid vara knappar, aldrig rullgardin (§H5).
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sl-optbtn';
          b.textContent = value;
          var ok = selectable(index, value);
          if (!ok) {
            b.disabled = true;
            b.classList.add('is-out');
            b.title = 'Slutsåld';
          }
          if (state.chosen[index] === value) {
            b.classList.add('is-on');
            b.setAttribute('aria-pressed', 'true');
          } else {
            b.setAttribute('aria-pressed', 'false');
          }
          b.addEventListener('click', function () {
            state.chosen[index] = value;
            render();
          });
          row.appendChild(b);
        });

        group.appendChild(row);
        elOptions.appendChild(group);
      });

      var v = current();
      elPrice.textContent = v ? money(v.price) : '';
      if (v && v.image) elImage.setAttribute('src', v.image);
      elAdd.disabled = !v || !v.available;
      elAdd.textContent = v && !v.available ? 'Slutsåld' : 'Lägg i varukorgen';
    }

    function open(data, image) {
      // Börja på den första köpbara varianten, så panelen aldrig öppnas
      // i ett omöjligt läge.
      var start = null;
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) { start = data.variants[i]; break; }
      }
      state = { data: data, chosen: (start || data.variants[0]).options.slice() };

      elName.textContent = data.title;
      elLink.setAttribute('href', data.url);
      elImage.setAttribute('alt', data.title);
      elImage.setAttribute('src', (start && start.image) || image || '');
      render();

      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    }

    function close() {
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    }

    dlg.querySelector('[data-sl-quick-close]').addEventListener('click', close);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) close();
    });

    elAdd.addEventListener('click', function () {
      var v = current();
      if (!v) return;
      elAdd.disabled = true;
      elAdd.textContent = 'Lägger till…';

      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        })
        .then(function () {
          close();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawer = document.querySelector('cart-drawer-component, #cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else window.location.href = cartRoot() + 'cart';
        })
        .catch(function () {
          elAdd.textContent = 'Något gick fel – försök igen';
          setTimeout(function () { render(); }, 2500);
        });
    });

    // Delegerat: korten kan renderas om av sektions-API:t.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-sl-quick]');
      if (!btn) return;
      var card = btn.closest('[data-sl-card]');
      var raw = card && card.querySelector('[data-sl-variants]');
      if (!raw) return;
      var img = card.querySelector('[data-sl-card-image]');
      try {
        open(JSON.parse(raw.textContent), img && img.getAttribute('src'));
      } catch (err) {
        // Trasig JSON ska inte döda kortet – låt länken ta över.
        window.location.href = card.querySelector('.sl-pcard__name').getAttribute('href');
      }
    });
  }

  /* ---------- 3f. Frakttröskel, bundle-rad och upsell (§I) ---------- */

  var cartState = null;

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // Annonsbaren får frakttröskeln så snart korgen inte är tom (§I1). Den
  // roterar mellan två budskap; vi skriver över det första och låter det
  // andra ligga kvar.
  function paintAnnouncement(cart) {
    if (!cart || !cart.item_count) return;
    var slot = document.querySelector(
      '#header-group .announcement-bar__message, #header-group [class*="announcement"] p, #header-group [class*="announcement"] span'
    );
    if (!slot) return;
    var left = 59900 - cart.total_price;
    slot.textContent = left > 0
      ? 'Du är ' + money(left) + ' från fri frakt'
      : 'Fri frakt – klart!';
  }

  // Ordern måste gå vidare till speditören märkt, inte bara till kunden.
  // Anteckningen följer med ordern och är det SourcinBox läser.
  //
  // Skrivningen sker bara när tillståndet faktiskt ändras – annars hade
  // varje omritning av korgpanelen blivit ett POST, och cart:refresh
  // hade ritat om igen i en rundgång.
  var SPLIT_NOTE = 'dela-forsandelse';
  var splitNoteState = null;

  function markSplitNote(cart, over) {
    var has = (cart.note || '').indexOf(SPLIT_NOTE) !== -1;
    if (over === has) { splitNoteState = over; return; }
    if (splitNoteState === over) return;
    splitNoteState = over;

    var note = (cart.note || '').replace(SPLIT_NOTE, '').trim();
    if (over) note = note ? note + ' ' + SPLIT_NOTE : SPLIT_NOTE;

    fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note })
    }).catch(function () {
      // Anteckningen är en intern markering, inte något kunden ser.
      // Misslyckas den ska korgen ändå fungera.
      splitNoteState = null;
    });
  }

  function paintCartExtras(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-sl-cartx]').forEach(function (root) {
      var threshold = Number(root.getAttribute('data-threshold')) || 59900;
      var left = threshold - cart.total_price;

      // Frakttröskeln
      var ship = root.querySelector('[data-sl-ship]');
      if (ship) {
        ship.hidden = cart.item_count === 0;
        var line = root.querySelector('[data-sl-ship-line]');
        var fill = root.querySelector('[data-sl-ship-fill]');
        var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
        if (fill) fill.style.inlineSize = pct + '%';
        if (line) {
          line.innerHTML = '';
          if (left > 0) {
            line.textContent = 'Du är ' + money(left) + ' från fri frakt';
          } else {
            line.textContent = 'Fri frakt – klart!';
            var tick = document.createElement('span');
            tick.className = 'sl-ship__tick';
            tick.setAttribute('aria-hidden', 'true');
            tick.textContent = '✓';
            line.appendChild(tick);
          }
        }
        ship.classList.toggle('is-done', left <= 0);
      }

      // 150-eurospärren (v4.1 §1). Taket är uträknat per destinationsland
      // i Liquid och ligger i data-splitcap, i minsta valutaenhet och
      // inklusive moms. Noll betyder "inget tak" – Sverige.
      var split = root.querySelector('[data-sl-split]');
      var cap = Number(root.getAttribute('data-splitcap')) || 0;
      if (split) {
        var over = cap > 0 && cart.total_price >= cap;
        split.hidden = !over;
        markSplitNote(cart, over);
      }

      // Trapprabattsraden (v3.1 §2): vid ett plagg pekar den på nästa
      // steg (−10 %), vid två på steget efter (−20 %). Vid tre eller fler
      // är rabatten redan tagen och raden tiger.
      var row = root.querySelector('[data-sl-bundlerow]');
      if (row) {
        var txt = row.querySelector('[data-sl-bundletext]');
        if (cart.item_count === 1) {
          if (txt) txt.textContent = 'Lägg till ett plagg till så sparar du 10 %';
          row.hidden = false;
        } else if (cart.item_count === 2) {
          if (txt) txt.textContent = 'Ett plagg till ger dig 20 % rabatt';
          row.hidden = false;
        } else {
          row.hidden = true;
        }
      }
    });
  }

  function refreshCartUi() {
    return fetchCart().then(function (cart) {
      cartState = cart;
      paintAnnouncement(cart);
      paintCartExtras(cart);
      return cart;
    });
  }

  // Flyttar in blocket överst i varukorgspanelen och på varukorgssidan.
  function mountCartExtras() {
    var tpl = document.getElementById('sl-cart-extras-template');
    if (!tpl) return false;
    var hosts = document.querySelectorAll(
      'cart-drawer-component .cart-items__wrapper, #cart-drawer .cart-items__wrapper, .cart-page .cart-items__wrapper'
    );
    var added = false;
    hosts.forEach(function (host) {
      if (host.querySelector('[data-sl-cartx]')) return;
      host.insertBefore(tpl.content.cloneNode(true), host.firstChild);
      added = true;
    });
    return added;
  }

  function initCartExtras() {
    if (mountCartExtras()) {
      refreshCartUi();
    } else if (!cartState) {
      // Ingen korgpanel i DOM:en än, men annonsbaren ska ändå stämma.
      refreshCartUi();
    } else {
      paintCartExtras(cartState);
    }
  }

  /* ---------- 3f. Utforska mer (v5.2 §5) ----------

     Knappen i .sl-bundlerow hette "Välj plagg" och navigerade till
     kollektionen. I varukorgslådan var det fel: lådan ligger ovanpå den
     sida kunden redan är på, så rätt sak är att stänga den och lämna
     kunden kvar.

     Lådan heter <theme-drawer id="cart-drawer"> och ligger runt en
     <dialog class="theme-drawer__dialog"> med <cart-drawer-component>
     inuti – läst ur snippets/cart-drawer.liquid. Det är theme-drawer som
     äger livscykeln: dess close() kör stängningsanimationen, nollställer
     --drawer-stack-order, lämnar tillbaka fokus till det som öppnade lådan
     och återställer scrollpositionen (assets/theme-drawer.js). Att i
     stället ta närmaste <dialog> och köra dialog.close() hade stängt lådan
     men hoppat över allt det – därför söks theme-drawer, inte dialogen.

     På /cart finns ingen sida att stanna kvar på. history.back() bara när
     referraren är vår egen domän; en direktöppnad /cart hade annars kastat
     kunden ut ur butiken.
  */

  function initExplore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-sl-explore]');
      if (!btn) return;
      e.preventDefault();

      var drawer = btn.closest('theme-drawer') ||
                   document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.close === 'function' && drawer.contains(btn)) {
        drawer.close();
        return;
      }

      var fallback = btn.getAttribute('data-sl-fallback') || '/collections/onesies';
      var sameHost = false;
      if (document.referrer) {
        try {
          sameHost = new URL(document.referrer).host === location.host;
        } catch (err) {
          sameHost = false;
        }
      }
      if (sameHost && history.length > 1) {
        history.back();
      } else {
        location.href = fallback;
      }
    });
  }

  /* ---------- 3g. Storlekshjälp (§H4) ---------- */

  function initSizeTool() {
    var LADDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];

    document.querySelectorAll('[data-sl-sizetool]').forEach(function (root) {
      if (root.dataset.slReady) return;
      root.dataset.slReady = '1';

      var out = root.querySelector('[data-sl-size-out]');
      var pick = { height: null, usual: null, fit: null };

      function render() {
        if (!pick.usual || !pick.fit) {
          out.textContent = '';
          return;
        }
        var i = LADDER.indexOf(pick.usual);
        if (i === -1) return;

        // Asiatiska storlekar: ett steg upp, två om kunden vill ha det löst.
        var steps = pick.fit === 'loose' ? 2 : 1;
        var suggestion = LADDER[Math.min(LADDER.length - 1, i + steps)];

        var msg = 'Vi föreslår ' + suggestion + '.';
        if (pick.height === 'over') {
          msg += ' Är du över 175 cm ligger plagglängden i underkant – ta den större storleken om du tvekar.';
        } else if (pick.height === 'under') {
          msg += ' Plagget är rymligt, så räkna med att ben och ärmar blir långa.';
        }
        out.textContent = msg;
      }

      function wire(attr, key) {
        var buttons = root.querySelectorAll('[' + attr + ']');
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () {
            buttons.forEach(function (o) {
              o.classList.remove('is-on');
              o.setAttribute('aria-pressed', 'false');
            });
            b.classList.add('is-on');
            b.setAttribute('aria-pressed', 'true');
            pick[key] = b.getAttribute(attr);
            render();
          });
        });
      }

      wire('data-sl-size-height', 'height');
      wire('data-sl-size-usual', 'usual');
      wire('data-sl-size-fit', 'fit');
    });
  }

  /* ---------- 3h. E-postinsamling (§I4) ---------- */

  function initSignup() {
    var dlg = document.getElementById('sl-signup');
    if (!dlg) return;

    // Bara startsidan – en popup på en produktsida står i vägen för ett
    // köp som redan är på gång.
    var main = document.getElementById('MainContent');
    if (!main || main.getAttribute('data-template') !== 'index') return;

    var KEY = 'sl-signup-seen';
    try {
      if (localStorage.getItem(KEY) === '1') return;
    } catch (err) {
      // Privat läge eller blockerad lagring: visa den inte alls hellre än
      // att visa den vid varje sidladdning.
      return;
    }

    var shown = false;

    function show() {
      if (shown) return;
      shown = true;
      try { localStorage.setItem(KEY, '1'); } catch (err) { /* strunt samma */ }
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
      cleanup();
    }

    function onScroll() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= 0.6) show();
    }

    // Avsikt att lämna: musen ut genom överkanten.
    function onLeave(e) {
      if (e.clientY <= 0) show();
    }

    function cleanup() {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseleave', onLeave);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseleave', onLeave);

    var close = dlg.querySelector('[data-sl-signup-close]');
    if (close) {
      close.addEventListener('click', function () {
        if (typeof dlg.close === 'function') dlg.close();
        else dlg.removeAttribute('open');
      });
    }
  }

  /* ---------- 4. Scroll-reveal ---------- */

  function initReveal() {
    var els = document.querySelectorAll('.sl-reveal');
    if (!els.length) return;
    if (CALM || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 4a. Kontorutan (v5.4) ----------

     Horizon har ingen <a href="/account"> i headern. Kontrollen är
     <shopify-account> inuti div.account-button.header-actions__action –
     en webbkomponent från Shopify som ritar sin egen knapp i shadow DOM
     och öppnar sin egen popover (base.css refererar
     shopify-account::part(dialog)). Att lyssna på klick där hade gett två
     paneler samtidigt, för komponenten öppnar sin egen oavsett vad vi gör
     med eventet.

     Därför byts kontrollen ut: vår länk flyttas in i samma behållare och
     headern får data-sl-account-inline, som CSS:en använder för att dölja
     <shopify-account>. Ordningen spelar roll – attributet sätts först när
     länken faktiskt ligger på plats, så en JS-miss aldrig lämnar butiken
     helt utan kontoingång.

     Stängknappen är kopplad här och inte med Horizons on:click="#sl-acct/close".
     Den deklarativa hjälpen i assets/component.js avbryter på
     `if (!(instance instanceof Component)) return` – en vanlig <dialog> är
     inte en Horizon-komponent, så attributet hade varit en tyst nolla. */

  function initAccount() {
    var tpl = document.getElementById('sl-account-link-template');
    var header = document.querySelector('#header-component');
    if (tpl && header && !header.querySelector('[data-sl-account]')) {
      var slot = header.querySelector('.account-button');
      if (slot) {
        slot.appendChild(tpl.content.cloneNode(true));
        header.setAttribute('data-sl-account-inline', '');
      }
    }

    var dlg = document.getElementById('sl-acct');
    if (!dlg || dlg.hasAttribute('data-sl-bound')) return;
    dlg.setAttribute('data-sl-bound', '');

    document.addEventListener('click', function (e) {
      var close = e.target.closest && e.target.closest('[data-sl-acct-close]');
      if (close && dlg.contains(close)) {
        dlg.close();
        return;
      }

      var link = e.target.closest && e.target.closest('[data-sl-account]');
      if (!link) return;

      // Mittenklick, Cmd/Ctrl-klick och Skift/Alt får gå till sidan som
      // vanligt, annars går "öppna i ny flik" förlorat.
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      // Utan dialogstöd: följ länken till Shopifys sida som förut.
      if (typeof dlg.showModal !== 'function') return;

      e.preventDefault();

      // showModal() och inte show(): bara den ritar ::backdrop, spärrar
      // sidan bakom och fångar fokus.
      if (!dlg.open) dlg.showModal();

      // Utan det här autofokuserar webbläsaren stängknappen, som då får en
      // synlig fokusring i samma ögonblick som rutan öppnas.
      var body = dlg.querySelector('.sl-acct__body');
      if (body) body.focus();
    });

    // Escape stänger av sig självt – <dialog> gör det, vi bygger inget eget.
  }

  /* ---------- 4b. Totalraden på produktsidan (v5.2 §3) ----------

     Två händelser krävs, och bara den ena är den specen gissade på:

     1. Antalet. Horizons plus- och minusknappar sätter input.value i JS och
        skickar sedan quantity-selector:update (assets/component-quantity-
        selector.js, onQuantityChange). Ett programmatiskt värdebyte utlöser
        inget native change-event, så enbart change på fältet hade missat
        varje klick på plus och minus – bara den som skriver siffran för
        hand och lämnar fältet hade uppdaterat totalen. Vi lyssnar därför på
        båda: quantity-selector:update för knapparna, change som skyddsnät.

     2. Variantbytet. Horizon skickar shopify:product:select – Shopifys
        standardhändelse, StandardEvents.productSelect ur @shopify/events,
        dispatchad på <variant-picker> i fetchUpdatedSection
        (assets/variant-picker.js). Den bubblar: temats egna lyssnare
        (product-price.js, sticky-add-to-cart.js) sitter på närmaste
        .shopify-section eller dialog. Den har inget att göra med
        "variant:change", som inte finns i temat.

        event.detail.variantId kommer synkront; event.promise resolvar
        senare med serverns nya HTML. Priset läses ur priskartan i
        sl-total.liquid, så raden hinner med redan i den synkrona delen.
  */

  function initTotal() {
    var box = document.querySelector('[data-sl-total]');
    if (!box) return;

    var prices = {};
    var raw = document.querySelector('[data-sl-total-prices]');
    if (raw) {
      try { prices = JSON.parse(raw.textContent) || {}; } catch (err) { prices = {}; }
    }

    var currency = box.getAttribute('data-currency') || 'SEK';
    var locale = box.getAttribute('data-locale') || 'sv';
    var tiered = box.getAttribute('data-tiered') === 'true';
    var fmt;
    try {
      fmt = new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency,
        minimumFractionDigits: 0, maximumFractionDigits: 0
      });
    } catch (err) {
      fmt = null;
    }

    function show(ore) {
      var whole = Math.round(ore / 100);
      return fmt ? fmt.format(whole) : whole.toLocaleString('sv-SE') + ' kr';
    }

    function qty() {
      var input = document.querySelector('[data-sl-total-qty], input[name="quantity"]');
      var n = parseInt(input && input.value, 10);
      return n > 0 ? n : 1;
    }

    function paint() {
      var n = qty();
      var unit = parseInt(box.getAttribute('data-unit'), 10) || 0;
      // Trappan är minsta antal i kollektionen onesies: 2 plagg −10 %,
      // 3 plagg −20 %. Båda rabatterna gäller antal, inte antal olika
      // artiklar, så tre av samma plagg räcker.
      var rabatt = tiered ? (n >= 3 ? 0.2 : n >= 2 ? 0.1 : 0) : 0;
      var sum = Math.round(unit * n * (1 - rabatt));

      var val = box.querySelector('[data-sl-total-value]');
      if (val) val.textContent = show(sum);

      var label = box.querySelector('[data-sl-total-label]');
      if (label) label.textContent = n > 1 ? 'Totalt för ' + n + ' plagg' : 'Totalt';

      var note = box.querySelector('[data-sl-total-note]');
      if (note) {
        note.hidden = rabatt === 0;
        if (rabatt) note.textContent = '−' + Math.round(rabatt * 100) + ' % dras av i kassan';
      }
    }

    document.addEventListener('quantity-selector:update', paint);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') paint();
    });
    document.addEventListener('shopify:product:select', function (e) {
      var id = e.detail && e.detail.variantId;
      if (id && Object.prototype.hasOwnProperty.call(prices, String(id))) {
        box.setAttribute('data-unit', prices[String(id)]);
      }
      paint();
    });

    paint();
  }

  function boot() {
    initCompleteLook();
    initSearchChips();
    initSearchField();
    initHeaderShadow();
    initEmptyCart();
    initCardSwatches();
    initQuickBuy();
    initCartExtras();
    initExplore();
    initSizeTool();
    initSignup();
    initReveal();
    initAccount();
    initTotal();
  }

  // Sökmodalen finns i DOM:en från start men öppnas senare – koppla om
  // chipsen när dialogen öppnas ifall temat renderat om innehållet.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[aria-controls="search-modal"], .header__search, [data-search-open]')) {
      setTimeout(initSearchChips, 60);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      watchCart();
    });
  } else {
    boot();
    watchCart();
  }

  // Horizon renderar om sektioner vid variantbyte – koppla på nytt.
  document.addEventListener('shopify:section:load', boot);
})();
